import { render } from "./QuoteSlider.vue?vue&type=template&id=768b598c&scoped=true"
import script from "./QuoteSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteSlider.vue?vue&type=script&setup=true&lang=js"

import "./QuoteSlider.vue?vue&type=style&index=0&id=768b598c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768b598c"],['__file',"src/components/Utility/QuoteSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "768b598c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('768b598c', __exports__)) {
    api.reload('768b598c', __exports__)
  }
  
  module.hot.accept("./QuoteSlider.vue?vue&type=template&id=768b598c&scoped=true", () => {
    api.rerender('768b598c', render)
  })

}


export default __exports__